import React, { forwardRef } from 'react'

import PropTypes from 'prop-types'
import MaterialTable, { MTableToolbar } from 'material-table'
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn
} from '@material-ui/icons'
import Pagination from '../Pagination/Pagination'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
}

const table = ({
  title,
  structure,
  recordData,
  rowActions,
  sortingDisabled,
  paginationDisabled,
  pagination,
  perPageChanged,
  pageChanged,
  search,
  loading,
  detailPanel,
  localization,
  translate,
  errorText,
  options
}) => {
  return (
    <React.Fragment>
      <MaterialTable
        icons={tableIcons}
        title={title}
        columns={structure}
        data={recordData}
        actions={rowActions}
        isLoading={loading}
        options={{
          actionsColumnIndex: -1,
          search: search,
          paging: false,
          sorting: !sortingDisabled,
          tableLayout: 'auto',
          rowStyle: {
            verticalAlign: 'top'
          },
          headerStyle: {
            whiteSpace: 'nowrap'
          },
          ...options
        }}
        localization={
          localization || {
            header: {
              actions: translate('action')
            },
            body: {
              emptyDataSourceMessage: translate('noRecordsToDisplay'),
              filterRow: {
                filterTooltip: translate('filter')
              }
            },
            toolbar: {
              searchPlaceholder: translate('search'),
              searchTooltip: translate('search')
            }
          }
        }
        detailPanel={detailPanel}
        components={{
          Toolbar: props => (
            <div>
              <MTableToolbar {...props} />
              <div style={{ padding: '0px 10px', color: 'red' }}>{errorText}</div>
            </div>
          )
        }}
      />
      {paginationDisabled ? null : (
        <Pagination
          pageChanged={pageChanged}
          perPageChanged={perPageChanged}
          pagination={pagination}
        />
      )}
    </React.Fragment>
  )
}

table.propTypes = {
  title: PropTypes.node,
  structure: PropTypes.array.isRequired,
  recordData: PropTypes.array.isRequired,
  rowActions: PropTypes.array,
  loading: PropTypes.bool,
  paginationDisabled: PropTypes.bool,
  pagination: PropTypes.shape({
    total: PropTypes.number,
    to: PropTypes.number,
    lastPage: PropTypes.number,
    from: PropTypes.number,
    currentPage: PropTypes.number,
    perPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  perPageChanged: PropTypes.func,
  pageChanged: PropTypes.func,
  search: PropTypes.bool,
  components: PropTypes.object
}

table.defaultProps = {
  title: '',
  rowActions: [],
  loading: false,
  structure: [],
  recordData: [],
  paginationDisabled: false,
  pagination: {
    total: 0,
    to: 0,
    lastPage: 0,
    from: 0,
    currentPage: 0,
    perPage: 0
  },
  search: true,
  localization: null
}

export default withTranslate(table)
